import { brands } from 'noddi-types';
import { cn } from 'noddi-ui-common';
import { NoddiLanguageSelector } from 'noddi-ui-web';
import { useLanguageContext } from 'noddi-web';

import { useCurrentBrand } from '../../stores/BrandStore/brandStore';
import { getSupportedLocales } from '../../utils/translation';
import { BrandLogo } from '../Brand/BrandLogo';
import { LogoLink } from './LogoLink';
import { NavWrapper } from './NavWrapper';
import { TronderdekkHeaderNav } from './TronderdekkHeaderNav';
import { usePageWidth } from './usePageWidth';

interface BasicHeaderNavProps {
  className?: string;
}

export const BasicHeaderNav = ({ className }: BasicHeaderNavProps) => {
  const { currentBrand } = useCurrentBrand();

  if (currentBrand === brands.tronderdekk) {
    return <TronderdekkHeaderNav />;
  }

  return <DefaultBasicHeaderNav className={className} />;
};

const DefaultBasicHeaderNav = ({ className }: BasicHeaderNavProps) => {
  const { currentLanguage, setCurrentLanguage } = useLanguageContext();
  const width = usePageWidth();

  return (
    <NavWrapper width={width}>
      <div className={cn('flex w-full items-center justify-between gap-5', className)}>
        <LogoLink>
          <BrandLogo />
        </LogoLink>
        <NoddiLanguageSelector
          collapseOnMobile
          className='text-black'
          supportedLanguages={getSupportedLocales()}
          currentLanguage={currentLanguage}
          setCurrentLanguage={setCurrentLanguage}
          dropDownOnRightSide
        />
      </div>
    </NavWrapper>
  );
};
